//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    type: {
      type: String,
      default: "month",
    },
  },
  data() {
    return {
      maxDate: new Date(),
      currentDate: new Date(),
    };
  },
  methods: {
    onConfirm(e) {
      this.$emit("confirm", e);
    },
    onCancel() {
      this.$emit("cancel", false);
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
  },
};
